export default{
    methods: {
        goToLinks(slug) {
            const routeData = this.$router.resolve({
                name: 'Links',
                query: { search: slug }
            });

            window.open(routeData.href, '_blank');
        },
        goToTheLinks(user) {
            const routeData = this.$router.resolve({
                name: 'Links',
                query: {
                    search: user
                }
            });

            window.open(routeData.href, '_blank');
        },
    }
}
